// Module
var code = ` <button [ngClass]="this.buttonClass" [ngStyle]="this.buttonStyle" type="button" (click)="this.onClick.emit(\$event); this.active = !this.active;" class="state-button"> <ng-content></ng-content> </button> `;
// Exports
export default code;